var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginalBgImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251.14 483.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -93.03,
    y1: 100.32,
    x2: 251.44,
    y2: 100.32,
    gradientTransform: "translate(78.96 71.6) rotate(20.89) scale(1.07 1.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -88.97,
    y1: 107.6,
    x2: 255.5,
    y2: 107.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -84.91,
    y1: 114.87,
    x2: 259.56,
    y2: 114.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -80.85,
    y1: 122.15,
    x2: 263.61,
    y2: 122.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -76.8,
    y1: 129.42,
    x2: 267.67,
    y2: 129.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -72.74,
    y1: 136.7,
    x2: 271.73,
    y2: 136.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -68.68,
    y1: 143.97,
    x2: 275.79,
    y2: 143.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -64.62,
    y1: 151.25,
    x2: 279.84,
    y2: 151.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -60.56,
    y1: 158.52,
    x2: 283.9,
    y2: 158.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -56.51,
    y1: 165.8,
    x2: 287.96,
    y2: 165.8,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m238.42,406.03c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.42-17.43-88.47-46.13-119.05C82.23,10.06,23.32,2.23,0,1l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m239.79,414.59c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.42-17.43-88.47-46.13-119.05C83.6,18.62,24.69,10.78,1.37,9.55l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m241.16,423.14c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.42-17.43-88.47-46.13-119.05C84.97,27.17,26.06,19.34,2.74,18.11l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m242.53,431.7c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.42-17.42-88.47-46.13-119.05C86.34,35.73,27.43,27.9,4.11,26.67l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m243.9,440.25c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.42-17.42-88.47-46.13-119.05C87.71,44.28,28.79,36.45,5.47,35.22l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m245.27,448.81c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.42-17.42-88.47-46.13-119.05C89.07,52.84,30.16,45.01,6.84,43.78l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m246.63,457.36c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.41-17.42-88.47-46.13-119.05C90.44,61.39,31.53,53.56,8.21,52.33l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m248,465.92c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.41-17.42-88.47-46.13-119.05C91.81,69.95,32.9,62.12,9.58,60.89l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m249.37,474.48c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.41-17.42-88.47-46.13-119.05-43.25-46.07-102.17-53.9-125.49-55.13l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m250.74,483.03c-51.3-22.17-82.19-49.78-91.8-82.06-7.37-24.75-.04-43.6,8.44-65.42,8.44-21.71,18.01-46.32,16.55-83.37-1.9-48.41-17.42-88.47-46.13-119.05-43.25-46.07-102.17-53.9-125.49-55.13l.05-1c23.44,1.24,82.66,9.11,126.16,55.44,28.88,30.76,44.49,71.03,46.41,119.69,1.46,37.26-8.14,61.97-16.62,83.77-8.42,21.65-15.69,40.35-8.42,64.77,9.52,31.99,40.22,59.39,91.24,81.43l-.4.92Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalBgImg1);
export default __webpack_public_path__ + "static/media/original-bg-img-1.a155b4991e0beaf74e5470130afe1f40.svg";
export { ForwardRef as ReactComponent };